































































import { Vue, Component, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import memberStore from '@/modules/member/member.store'
import authStore from '@/modules/auth/auth.store'
import { IdentityAPI } from '@/api/identity'
import ServerError from '@/utils/server_error'
import { invokeDialogCallback } from '@/utils/verification'

@Component
export default class JoinTournamentSetDiscordIdDialog extends Vue {
  memberModule = getModule(memberStore, this.$store)
  userModule = getModule(authStore, this.$store)

  discordIdRules: any = []
  loading: boolean = false
  discordId: string | null = null
  validate: boolean = false

  created() {
    this.discordIdRules = [
      (v: any) =>
        (!!v && /^(.{2,32})#(\d{4})$/.test(v)) ||
        this.$t('MemberEditProfileDialog.DiscordIdFormatInvalid')
    ]
  }

  @Watch('isVisible')
  onVisibilityChanged(value: boolean) {
    if (value) {
      this.discordId = ''
      this.validate = false
    }
  }

  get isVisible() {
    return this.memberModule.isDiscordIdDialogVisible
  }

  set isVisible(value: boolean) {
    this.memberModule.setIsDiscordIdDialogVisible({
      isVisible: value
    })
  }

  async submit() {
    if (!this.validate) return

    this.loading = true

    try {
      await IdentityAPI.setAccountDiscordId({
        discordId: this.discordId
      })
      await this.userModule.fetchAccountInfo()

      this.isVisible = false
      invokeDialogCallback().then()
    } catch (err) {
      if (err instanceof ServerError) {
        this.$toast.error(err.getMessage())
      } else {
        this.$toast.error('System error')
      }
      console.error(err)
    } finally {
      this.loading = false
    }
  }
}
